
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7d9ac306&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductReviewDetail.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductReviewDetail.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-7d9ac306!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductReviewDetail.vue"),
  /* scopeId */
  "data-v-7d9ac306",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductReviewDetail.vue
// module id = 537
// module chunks = 2